
import { TestResult } from "@/hooks/useTestResults";
import { calculateAverageScore } from "../test-scoring/calculations";

export const findImprovementDate = (sortedResults: TestResult[]): string | undefined => {
  for (let i = 0; i < sortedResults.length - 2; i++) {
    if (
      sortedResults[i].score < sortedResults[i + 1].score &&
      sortedResults[i + 1].score < sortedResults[i + 2].score
    ) {
      return sortedResults[i + 2].created_at;
    }
  }
  return undefined;
};

export const findConsistencyDate = (sortedResults: TestResult[]): string | undefined => {
  for (let i = 0; i <= sortedResults.length - 3; i++) {
    if (
      sortedResults[i].score >= 80 &&
      sortedResults[i + 1].score >= 80 &&
      sortedResults[i + 2].score >= 80
    ) {
      return sortedResults[i + 2].created_at;
    }
  }
  return undefined;
};

export const findMasteryDate = (sortedResults: TestResult[]): string | undefined => {
  const categories = new Set(sortedResults.map(result => result.tests.category));
  
  for (const category of Array.from(categories)) {
    const categoryResults = sortedResults.filter(result => result.tests.category === category);
    if (categoryResults.length >= 3 && categoryResults.every(result => result.score >= 90)) {
      return categoryResults[categoryResults.length - 1].created_at;
    }
  }
  return undefined;
};

export const findCategoryMasteryDate = (sortedResults: TestResult[], category: string): string | undefined => {
  const categoryResults = sortedResults.filter(result => result.tests.category === category);
  
  if (categoryResults.length < 3) return undefined;
  
  for (let i = 2; i < categoryResults.length; i++) {
    const currentResults = categoryResults.slice(0, i + 1);
    const average = calculateAverageScore(currentResults);
    
    if (average >= 90) {
      return categoryResults[i].created_at;
    }
  }
  
  return undefined;
};
